// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/stylesheets/partials/general-info.scss
// module id = 441
// module chunks = 0